var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 45.5,
    r: 45.5,
    fill: "url(#paint0_linear_7206_1969)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.224 29.4444C41.224 28.9538 41.6222 28.5556 42.1128 28.5556H47.4462C47.9368 28.5556 48.3351 28.9538 48.3351 29.4444V32.1111H41.224V29.4444ZM35.8906 57H53.6684V32.1111H51.8906V29.4444C51.8906 26.9947 49.896 25 47.4462 25H42.1128C39.6631 25 37.6684 26.9947 37.6684 29.4444V32.1111H35.8906V57ZM57.2222 32.1111V57C60.1627 57 62.5556 54.6071 62.5556 51.6667V37.4444C62.5556 34.504 60.1627 32.1111 57.2222 32.1111ZM27 37.4444C27 34.504 29.3929 32.1111 32.3333 32.1111V57C29.3929 57 27 54.6071 27 51.6667V37.4444Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7206_1969",
    x1: 27.268,
    y1: -2.88167,
    x2: 55.3656,
    y2: 100.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2062F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7337FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.22d08ea591ce835281a1c90e456c33c7.svg";
export { ForwardRef as ReactComponent };